<template>
        <span>
                <el-button type="primary"
                        icon="el-icon-plus"
                        size="small"
                        @click="openDialog"
                >制定临时任务</el-button>
                <el-dialog
                        title="制定临时任务"
                        width="80%"
                        top="60px"
                        :bottom="0"
                        append-to-body
                         style="max-hight:100vh;margin-bottom:0"
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        class="taskManagement-addForm"
                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        制定临时任务
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll;">
                <avue-form ref="form" v-if="dialogVisible" v-model="form" :option="option" @reset-change="emptytChange" @submit="addTemTask">
                        <template slot="standardId">
                                  <el-select v-model="form.standardId" placeholder="请选择">
                                        <el-option
                                        v-for="item in conprehensiveStandard"
                                        :key="item.standardId"
                                        :label="item.standardName"
                                        :value="item.standardId">
                                        </el-option>
                                </el-select>
                        </template>
                        <!-- 任务日期 -->
                        <template slot="executeDate">
                                <el-date-picker
                                        v-model="form.executeDate"
                                        type="date"
                                        :picker-options="pickerOptions"

                                        placeholder="请选择 任务日期">
                                </el-date-picker>
                        </template>
                        <template slot="timeQuantum">
                                <select-time
                                        :value.sync="form.timeQuantum"
                                        ref="selectTimeAdd"
                                >
                                </select-time>
                        </template>
                        <template slot="orderModuleType">
                                <el-cascader
                                v-model="form.orderModuleType"
                                :disabled="orderModuleTypeDisabled"
                                :options="cascaderOptions"
                                placeholder="请选择关联工单类型"
                                :props="{ checkStrictly: true }"
                                ></el-cascader>
                        </template>
                        <template slot="executeUserId">
                                <div style="display:flex;" v-if="form.orderRelateFlag==0">
                                        <span style="margin-right:10px;">共有</span>
                                        <choicePeople  :allUserList='realInspectManList' :remainUserListInside.sync="realInspectManList" :projectId="form.projectId" placeholder="请选择 计划人员"  message="请选择巡检人"  ></choicePeople>
                                        <span style="margin-left:10px;">参与计划</span>
                                </div>
                                <div style="display:flex;" v-else>
                                        <span style="margin-right:10px;">共有</span>
                                        <selectGroupUser ref="selectGroupUser" :value.sync="form.executeUserId" :projectId.sync="form.projectId" :moduleType.sync='form.orderModuleType[0]'  placeholder="请选择 计划人员" :subModuleId.sync="form.orderModuleType[1]"></selectGroupUser>
                                        <span style="margin-left:10px;">参与计划</span>
                                </div>

                        </template>
                        <template slot="taskContent">
                                <div>
                                        <el-row>
                                                <selectArea v-if="dialogVisible && form.type == 3" :taskContentData.sync="taskContentData"  :projectId.sync='form.projectId'></selectArea>
                                               <relateDevice @getDeviceInfo="getDeviceInfo" v-if="dialogVisible && form.type != 3" :taskContentData.sync="taskContentData"  :taskType.sync="form.type" :standardId='standardId' :projectId.sync='form.projectId'></relateDevice>
                                               <el-button size="small" type="primary" @click="removeSelect">移除</el-button>
                                               <el-button size="small" type="primary" @click="moveUpSelect">上移</el-button>
                                               <el-button size="small" type="primary" @click="moveDownSelect">下移</el-button>
                                        </el-row>
                                        <el-row style="margin-top:20px;">
                                               <avue-crud
                                               :data="taskContentData"
                                               :option="crudOption"
                                                ref="crud"
                                                @onLoad="onLoad"
                                                :table-loading="loading"
                                                @selection-change="selectionChange"

                                               >
                                                <template slot="name" slot-scope="scope">
                                                        <span>{{scope.row.name}}</span>
                                                </template>
                                                <template slot="standardName" slot-scope="scope">
                                                        <div v-if="form.type==1">
                                                                <div v-if="!scope.row.showEdit">
                                                                        <div>{{scope.row.standardName}}</div>
                                                                        <el-button v-if="scope.row.standardName" size="mini" type="primary" plain @click="changeStandard(scope.row)">切换标准</el-button>
                                                                </div>
                                                                <div v-else>
                                                                        <el-select  v-model="scope.row.standardId" placeholder="请选择" @change="(val)=>{
                                                                                standardChange(scope.row)}">
                                                                                <el-option
                                                                                        v-for="item in scope.row.deviceInspectStandard"
                                                                                        :key="item.id"
                                                                                        :label="item.name"
                                                                                        :value="item.id">
                                                                                </el-option>
                                                                        </el-select>
                                                                        
                                                                </div>
                                                        </div>
                                                        <div v-else><span>{{scope.row.standardName}}</span></div>

                                                </template>
                                               </avue-crud>
                                        </el-row>
                                </div>
                        </template>
                        <template slot="taskNotifyAheadNum">
                                <div>
                                        <el-input  @input="taskNotifyAheadNumInput" v-model="form.taskNotifyAheadNum" placeholder="请输入 任务通知时限">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskNotifyAheadUnit">
                                                                <option
                                                                        v-for="item in  taskNotifyAheadUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskFinishPicMustFlag" true-label="1" false-label="0" >巡检时强制提交照片，数量1~4张</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskExecuteForceSequenceFlag" true-label="1" false-label="0">强制按巡检内容书顺序巡检</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <template slot="taskOverdueTimeNum">
                                <div>
                                        <el-input  @input="taskOverdueTimeNumInput" v-model="form.taskOverdueTimeNum" placeholder="请输入 任务过期时限">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskOverdueTimeUnit">
                                                                <option
                                                                        v-for="item in  taskOverdueTimeUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueCloseFlag" true-label="1" false-label="0">逾期任务自动关闭</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueSubmitForbidFlag" true-label="1" false-label="0">任务过期不允许执行</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <!-- <template slot-scope="scope" slot="menuForm">
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </template> -->

                </avue-form>
                </div>
                <template slot="footer">
                        <div style="text-align:right;">
                                <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="$refs.form.submit();">保 存</el-button>
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                </el-dialog>
        </span>
</template>
<script>

import {
        addTemTask,
        getDictionary,
        getOrderType,
        standardDetailByDeviceId,
         getBisDictData,
        getStandardName
} from "@/api/crmedical/device/taskManagement";
import selectTime from "../components/select-time-box.vue";
import selectGroupUser from "../components/user-select-box.vue";
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import {areaOption,deviceOption,omitNumber} from "./option.js";
import relateDevice from '../components/choice-device';
import selectArea from "../components/choice-area.vue"
export default {
        components:{selectTime,choicePeople,selectGroupUser,relateDevice,selectArea},
        props:{
                projectId:{
                        type:String,
                        default:'',
                }
        },
        data(){
                return{
                        orderModuleTypeDisabled:false,
                        cascaderOptions:[],
                        taskContentData:[],
                        taskContentDataIds:[],
                        loading:false,
                        data:[{test:'test'}],
                        taskNotifyAheadUnitList:[
                                {
                                        dictKey:1,
                                        dictValue:'小时'
                                }
                        ],
                        taskOverdueTimeUnitList:[],
                        isEdit:false,
                        realInspectManList:[],
                        selectedTime:[],
                        dialogVisible:false,
                        dialogFull:false,
                        selectTimeFlag:false,
                        selectionData:[],
                        form:{
                                projectId:'',
                                executeUserId:[],
                        },
                        crudOption:deviceOption,
                        // 可选择日期
                        pickerOptions:{
                                disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
                                }
                        },
                        option:{
                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                submitBtn:false,
                                labelWidth:120,
                                column:[
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                type:'select',
                                                span:8,
                                                cascaderItem:['orderModuleType'],
                                                dicUrl:'/api/v4ward/project/getProjectList',
                                                props:{
                                                        label:"name",
                                                        value:'id'
                                                },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择项目",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "任务类型",
                                                prop: "type",
                                                span:8,
                                                cascaderItem:['orderModuleType'],
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                dicUrl:'/api/blade-system/dict/dictionary?code=task_type',
                                                type:"select",
                                                rules: [{
                                                        required: true,
                                                        message: "请选择任务类型",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "任务子类型",
                                                prop: "subTypeId",
                                                 dicData:[],
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                type:"select",
                                                span:8,

                                        },
                                        {
                                                label: "任务名称",
                                                prop: "name",
                                                type:"input",
                                                span:24,
                                                maxlength:20,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入任务名称",
                                                        trigger: "change"
                                                }]

                                        },
                                        {
                                                label: "任务日期",
                                                prop: "executeDate",
                                                type: 'date',
                                                span:8,
                                                formslot:true,
                                                pickerOptions: {
                                                        disabledDate(time) {
                                                                return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
                                                        }
                                                },
                                                format: 'yyyy-MM-dd',
                                                valueFormat: 'yyyy-MM-dd',
                                                rules: [{
                                                        required: true,
                                                        message: "请选择执行日期",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                type: 'radio',
                                                label: '关联工单',
                                                value:1,
                                                dicData: [
                                                        {
                                                                label: '是',
                                                                value: 1
                                                        },
                                                        {
                                                                label: '否',
                                                                value: 0
                                                        },
                                                ],
                                                span: 8,
                                                display: true,
                                                props: {
                                                        label: 'label',
                                                        value: 'value'
                                                },
                                                prop: 'orderRelateFlag'
                                        },
                                        {
                                                label: "关联工单类型",
                                                prop: "orderModuleType",
                                                type:"tree",
                                                formslot:true,
                                                // props:{
                                                //         label:'orderModuleTypeName',
                                                //         value:'orderModuleType',
                                                //         children:'subModuleList'
                                                // },
                                                span:8,
                                                // dicUrl:`/api/v4ward/taskordertype/getOrderType?taskType={{type}}&projectId={{projectId}}`

                                                // rules: [{
                                                //         required: true,
                                                //         message: "请选择任务子类型",
                                                //         trigger: "change"
                                                // }]
                                        },

                                        {
                                                label: "时间段",
                                                formslot:true,
                                                prop: "timeQuantum",
                                                span:24,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入具体时间段，格式为hh:mm~hh:mm+d,hh:mm~hh:mm+d，其中hh:mm为小时分钟，d代表跨天天数",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "计划人员",
                                                formslot:true,
                                                prop: "executeUserId",
                                                // rules: [{
                                                //         required: true,
                                                //         message: "请选择任务人员",
                                                //         trigger: "change"
                                                // }],
                                                span:24,

                                        },
                                        {
                                                label: "标准名称",
                                                prop: "standardId",
                                                dicData:[],
                                                props:{
                                                        label:'standardName',
                                                        value:'standardId',
                                                },
                                                type:"select",
                                                span:12,
                                                rules: [{
                                                        required: true,
                                                        message: "请选择巡检标准",
                                                        trigger: "change"
                                                }],
                                                formslot:true,
                                                display:false
                                        },
                                        {
                                                label: "任务内容",
                                                formslot:true,
                                                prop: "taskContent",
                                                rules: [{
                                                        required: true,
                                                        message: "请添加任务内容",
                                                        trigger: "change"
                                                }],
                                                span:24,

                                        },
                                        {
                                                title: '分割线',
                                                component: 'el-divider',
                                                span: 24 ,
                                                labelWidth: '0px',
                                                params: {
                                                        html: '<h3 style=\"color:#333\">执行任务要求</h3>',
                                                        contentPosition: 'left'
                                                },
                                                prop: '1632968429167_6112'
                                        },
                                        {
                                                label: "任务通知时限",
                                                formslot:true,
                                                prop: "taskNotifyAheadNum",
                                                span:12,

                                        },
                                        {
                                                label: "任务过期时限",
                                                formslot:true,
                                                prop: "taskOverdueTimeNum",
                                                span:12,

                                        },

                                ]
                        },
                        selectIds:"",
                        conprehensiveStandard :[]
                }
        },
        watch:{
                'form.subTypeId'(){
                        let subTypeIdColumn = this.findObject(this.option.column,"standardId");
                        if(this.form.subTypeId==''||this.form.subTypeId==undefined){
                                 subTypeIdColumn.display =false
                        }else{
                                console.log("ducu",this.form.subTypeId)
                                subTypeIdColumn.display =true
                                this.form.standardId = ''
                                this.getStandardBysubTypeId(this.form.subTypeId,this.form.projectId).then(res=>{
                                       this.conprehensiveStandard  = res
                                        // if(res.length ==0){
                                        //         subTypeIdColumn.dicData =[]
                                        //         subTypeIdColumn.display =false
                                        //         this.$nextTick(()=>{
                                        //                 subTypeIdColumn.display =true
                                        //         })
                                        // }else{
                                        //          subTypeIdColumn.dicData = res
                                        // }
                                })
                                
                        }
                },
                'projectId'(){
                        this.form.projectId = this.projectId;
                },
                "form.projectId"(val){
                        console.log(val)
                        this.getOrderType();
                        this.realInspectManList = [];

                        if(this.form.orderRelateFlag==1){
                                this.$refs.selectGroupUser.reset();
                        }
                },
                "form.type"(val){
                        let column = JSON.parse(JSON.stringify(this.option.column));

                        let subTypeIdColumn = this.findObject(this.option.column,"subTypeId");
                        this.form.subTypeId =''
                          this.findObject(this.option.column,"standardId").display =false;
                        if(val==1){
                                this.crudOption = deviceOption ;
                                subTypeIdColumn.rules = [];
                                subTypeIdColumn.disabled = true;
                        }else if(val==2){
                                console.log(subTypeIdColumn)
                                this.crudOption = deviceOption;
                                subTypeIdColumn.rules = [];
                                subTypeIdColumn.disabled = true;

                        }else if(val==3){
                                 console.log('ddd',subTypeIdColumn)
                                this.crudOption = areaOption;
                                subTypeIdColumn.disabled = false;

                                subTypeIdColumn.rules =[{required: true, message: "请选择任务子类型",trigger: "change"}]
                                getBisDictData({
                                        projectId:this.form.projectId,
                                        code:'project_general_inspect_type'
                                }).then(res=>{
                                        subTypeIdColumn.dicData = res.data
                                })
                        }else{
                                this.crudOption = deviceOption;
                                subTypeIdColumn.rules = [];
                                subTypeIdColumn.disabled = true;
                        }
                        this.taskContentData = [];
                        this.taskContentDataIds = [];
                        column[2] = subTypeIdColumn
                        this.option.column = column;
                        this.getOrderType();
                        // getOrderType({taskType:this.form.type}).then(res=>{

                        //         let orderModuleTypeColumn = this.findObject(this.option.column,"orderModuleType");
                        //         console.log(orderModuleTypeColumn)
                        //         orderModuleTypeColumn.dicData = res.data;
                        // })



                },
                "form.orderRelateFlag"(val){
                        if(this.form.orderRelateFlag==1){
                                setTimeout(()=>{
                                        this.$refs.selectGroupUser.reset();
                                })

                        }else{
                                this.realInspectManList = [];
                                this.form.orderModuleType = "";
                        }
                        let column = JSON.parse(JSON.stringify(this.option.column));

                        let executeUserIdColumn = this.findObject(this.option.column,"executeUserId");
                        let orderModuleTypeColumn = this.findObject(this.option.column,"orderModuleType");
                        if(val==1){
                                this.orderModuleTypeDisabled = false;
                                executeUserIdColumn.rules = [];
                                orderModuleTypeColumn.disabled = false;
                                orderModuleTypeColumn.rules = [{required: true,message: "请选择任务子类型",trigger: "change"}]

                        }else{
                                this.orderModuleTypeDisabled = true;
                                orderModuleTypeColumn.disabled = true;
                                orderModuleTypeColumn.rules = [];
                                executeUserIdColumn.rules =[{required: true, message: "请选择计划人员",trigger: "change"}]
                        }
                        column[6] = orderModuleTypeColumn;
                        column[8] = executeUserIdColumn;
                        this.option.column = column;
                },
                "realInspectManList"(val){
                        if(val.length>0){
                                this.form.executeUserId = val;

                        }else{
                                this.form.executeUserId = [];
                        }
                },
                "taskContentData"(val){
                        if(val.length>0){
                                this.form.taskContent = true;
                        }else{
                                this.form.taskContent = "";
                        }
                }

        },
        created(){

        },
        mounted(){
                // this.$nextTick(()=>{
                //         this.loading=false;
                //         this.$refs.crud.init();
                // })
        },
        methods:{
                 //根据工单子类型获取标准
               async  getStandardBysubTypeId(inspectType,projectId){
                      console.log("89898")
                        let data =[]
                     await   getStandardName({
                                projectId,
                                inspectType
                        }).then(res=>{
                                  data = res.data 
                        })
                        return data
                },
                 standardChange(row){
                        row.deviceInspectStandard.forEach(element => {
                                if(element.id == row.standardId){
                                        row.standardName =element.name
                                }
                        });
                         row.showEdit = false
                 },
                changeEnd(row){
                        row.showEdit = false
                },
                changeStandard(row){
                        console.log('kkk',row)
                        if(!row.deviceInspectStandard){
                                standardDetailByDeviceId({deviceId:row.id}).then(res=>{
                                this.$set(row,'deviceInspectStandard',res.data)
                                this.$set(row,'showEdit',true)
                        })
                        }
                        this.$set(row,'showEdit',true)
                        // row.isEdit = true
                },
                getDeviceInfo(data){
                        console.log("dddxzxcxzc")
                        if(this.form.type =='1'){
                                 data.forEach(ele=>{
                                         this.$set(ele,'showEdit',false)
                                // if(ele.deviceInspectStandard.length>0){
                                //         if(ele.standardId==''){
                                //                 ele.standardId = ele.deviceInspectStandard[0].id
                                //         }

                                // }

                        })
                        this.taskContentData =[...data]
                        console.log(this.taskContentData)
                        }

                },
                onLoad(){
                        this.loading=false;
                },
                // 获取关联工单类型
                getOrderType(){
                        console.log(this.form.orderRelateFlag)
                        console.log(this.form.orderRelateFlag===0)
                        if(this.form.orderRelateFlag===0){
                                return;
                        }
                        console.log(121231231231231231231231)
                        this.cascaderOptions = [];
                        this.form.orderModuleType = "";
                        if(this.form.type && this.form.projectId){
                                getOrderType({taskType:this.form.type,projectId:this.form.projectId}).then(res=>{

                                                let temArr = [];
                                                if(res.data.orderModuleType){
                                                        let temObj = {};
                                                        temObj.label = res.data.orderModuleTypeName;
                                                        temObj.value = res.data.orderModuleType;
                                                        temObj.children = [];
                                                        if(res.data.subModuleList){
                                                                res.data.subModuleList.forEach(ele=>{
                                                                        let a = {
                                                                                label:ele.name,
                                                                                value:ele.id
                                                                        };
                                                                        temObj.children.push(a);

                                                                })
                                                        }

                                                        temArr.push(temObj);
                                                        this.cascaderOptions = temArr;
                                                }





                                }).catch(err=>{
                                        this.cascaderOptions = [];
                                })
                        }

                },
                // 控制输入框输入数字
                taskNotifyAheadNumInput(e){
                        this.form.taskNotifyAheadNum = omitNumber(e)
                },
                // 控制输入框输入数字
                taskOverdueTimeNumInput(e){
                        this.form.taskOverdueTimeNum = omitNumber(e)
                },
                // 数据准备
                async initData(){
                        // 任务提前通知时限单位
                        await getDictionary("task_notify_ahead_unit").then(res=>{
                                this.taskNotifyAheadUnitList = res.data;
                                this.form.taskNotifyAheadUnit = res.data[0]?res.data[0].dictKey:'';
                        })
                        // 任务过期通知时限单位
                        await getDictionary("task_overdue_time_unit").then(res=>{
                                this.taskOverdueTimeUnitList = res.data;
                                this.form.taskOverdueTimeUnit = res.data[0]?res.data[0].dictKey:'';
                        })
                },
                // 移除
                removeSelect(){
                        let temArr = [];
                        this.taskContentData.forEach((ele,index)=>{
                                if(this.selectIds.indexOf(ele.id)<0){
                                        temArr.push(ele)
                                }
                        })
                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)
                },
                // 排序方法
                compare(property) {
                        return function (a, b) {
                                var value1 = a[property];
                                var value2 = b[property];
                                return value1 - value2;
                        }
                },
                // 上移
                moveUpSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[0].id)>-1){
                                this.$message({
                                        message: '已经到顶了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }
                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));
                        // this.selectionData.reverse();
                        this.selectionData.sort(this.compare("$index"));
                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })
                        this.selectionData.forEach((ele,index)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                if(i>-1){

                                        [this.taskContentDataIds[i-1],this.taskContentDataIds[i]] = [this.taskContentDataIds[i],this.taskContentDataIds[i-1]];
                                        [temArr[i-1],temArr[i]] = [temArr[i],temArr[i-1]]
                                }
                        })



                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)
                },
                // 下移
                moveDownSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[this.taskContentData.length-1].id)>-1){
                                this.$message({
                                        message: '已经到底了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }

                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));
                        this.selectionData.sort(this.compare("$index"));
                        this.selectionData.reverse();
                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })
                        this.selectionData.forEach((ele,index)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                if(i>-1){

                                        [this.taskContentDataIds[i],this.taskContentDataIds[i+1]] = [this.taskContentDataIds[i+1],this.taskContentDataIds[i]];
                                        [temArr[i],temArr[i+1]] = [temArr[i+1],temArr[i]]
                                }
                        })



                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)

                },
                // 任务内容 选择的数据
                selectionChange(val) {

                        this.selectionData = val;
                        console.log(this.selectionData)
                        let Ids = [];

                        val.forEach((element) => {
                                Ids.push(element.id);
                        });
                        this.selectIds = Ids.join(',');
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                if(done){
                                        done();
                                        this.selectTimeFlag = false;

                                }else{
                                        this.selectTimeFlag = false;
                                        self.dialogVisible = false;
                                }
                        })
                        .catch(()=> {
                                if(!done){
                                        this.selectTimeFlag = false;
                                        self.dialogVisible = false;
                                }
                        });
                },
                // 打开弹窗
                openDialog(){
                        console.log(this.form)
                        this.taskContentData = [];
                        this.form = {
                                executeDate:"",
                                executeUserId:[],
                                name:"",
                                orderModuleType:"",
                                orderRelateFlag:1,
                                subTypeId:'',
                                timeQuantum:'',
                                taskOverdueTimeUnit:'0',
                                taskOverdueTimeNum:'',
                                taskOverdueSubmitForbidFlag:'0',
                                taskOverdueCloseFlag:'0',
                                taskNotifyAheadUnit:'0',
                                taskNotifyAheadNum:'',
                                taskFinishPicMustFlag:'0',
                                taskExecuteForceSequenceFlag:'',

                        };

                        this.form.projectId = this.projectId;
                        this.dialogVisible = true;
                        this.selectTimeFlag = true;
                        this.form.type = '';
                        this.initData();
                },
                // 新增临时任务
                addTemTask(form,done){
                        console.log(form)
                        console.log("ddddddxcxcxzc",this.taskContentData)
                        // return;
                        form.executeDate = this.dayjs(form.executeDate).format("YYYY-MM-DD 00:00:00");
                        form.targetList = [];
                        this.taskContentData.forEach(ele=>{
                                let obj = {
                                        deviceId:ele.id,
                                        standardId:ele.standardId
                                }
                                form.targetList.push(obj)
                        })
                        if(form.orderModuleType.length!=0){
                                form.orderSubModuleId = form.orderModuleType[1];
                                form.orderModuleType = form.orderModuleType[0];
                        }
                        form.userList = [];
                        if(form.orderRelateFlag==1){
                                form.userList = form.executeUserId
                        }else{
                                this.realInspectManList.forEach(ele=>{
                                        form.userList.push(ele.id);
                                })
                        }

                        addTemTask(form).then(res=>{
                                this.dialogVisible = false;
                                this.selectTimeFlag = false;
                                this.$emit('onload')
                                done();
                        })
                        done();

                },
                // 获得时间选择器传来的值
                getTime(time) {
                        // this.inspectplanAddForm.timeQuantum = time;
                        console.log(time);
                        if(time){
                                let timeList = [];
                                time.forEach((ele,index)=>{
                                        timeList.push(ele.time);
                                        })
                                this.form.timeQuantum = timeList.join(',');
                        }
                },
        }
}
</script>

<style lang="scss" >
.taskManagement-addForm{
        .avue-dialog__footer{
                display: flex;
                justify-content:flex-end;
        }
        .el-form-item__error{
                position: relative;
        }
        // .taskContentLabel::before{
        //         content: " * ";
        //         color: #f00;
        // }

}

</style>